export default async function RestUploadMimetypeService(data) {
  const endpoint = "/api/allowedMimeTypes";

  try {
    const res = await fetch(endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    });
    return await res.clone().text();
  } catch (res_1) {
    return "false";
  }
}
